import React, { useState } from 'react';
import { useModelVersionEvents } from 'src/hooks/useModelVersionEvents';

import { useParams } from 'react-router-dom';
import { ModelVersionEventFormModal } from 'src/components/ModelVersionEventFormModal';
import { ClientSideTable } from 'src/components/ClientSideTable';
import { PermissionAwareButton } from 'src/components/PermissionAwareButton';
import { ModelVersionEvent } from 'src/context/apiState';
import { Application } from 'src/types/application';
import { SpaceBetween } from '@cloudscape-design/components';

export const ModelVersionEventsTable = () => {
  const params = useParams();
  const { data, isLoading, error } = useModelVersionEvents({
    versionId: params.modelVersionId,
  });

  const [modelVersionEventModalVisible, setModelVersionEventModalVisible] =
    useState<boolean>(false);
  const [modelVersionEventModalMode, setModelVersionEventModalMode] = useState<
    'New' | 'Edit' | 'Delete'
  >('New');
  const [modelEventModalValues, setModelEventModalValues] = useState<any>(null);

  const showModelEventModal = (
    mode: 'New' | 'Edit' | 'Delete',
    values: any,
  ) => {
    setModelEventModalValues(values);
    setModelVersionEventModalMode(mode);
    setModelVersionEventModalVisible(true);
  };

  return (
    <>
      <ClientSideTable
        columnDefinitions={[
          {
            header: 'Event Id',
            sortingField: 'id',
            id: 'event-id',
            cell: (item: ModelVersionEvent) => item.id,
          },
          {
            header: 'Event Type',
            sortingField: 'type',
            id: 'event-type',
            cell: (item: ModelVersionEvent) => item.type,
          },
          {
            header: 'S3 Bucket',
            sortingField: 's3Bucket',
            id: 's3-bucket',
            cell: (item: ModelVersionEvent) => item.s3Bucket,
          },
          {
            header: 'S3 Prefix',
            sortingField: 's3Prefix',
            id: 's3-prefix',
            cell: (item: ModelVersionEvent) => item.s3Prefix,
          },
          {
            header: 'Operator Name',
            sortingField: 'operatorName',
            id: 'operator-name',
            cell: (item: ModelVersionEvent) => item.operatorName,
          },
          {
            id: 'updatedDate',
            header: 'Updated Date',
            cell: (item: Application) => {
              const date = new Date(parseInt(item.updatedDate) * 1000);
              return date.toUTCString();
            },
            sortingField: 'updatedDate',
          },
          {
            id: 'updatedBy',
            header: 'Updated By',
            cell: (item: Application) => item.updatedBy,
            sortingField: 'updatedBy',
          },
          {
            id: 'actions',
            header: 'Actions',
            cell: (item: Application) => (
              <SpaceBetween
                direction="horizontal"
                size="xs"
                alignItems="center"
              >
                <PermissionAwareButton
                  onClick={() => showModelEventModal('Edit', item)}
                  variant="normal"
                  wrapText={false}
                  requiredPermission="ADMINISTER"
                  actionDescription="edit model version events"
                >
                  Edit
                </PermissionAwareButton>
                <PermissionAwareButton
                  onClick={() => showModelEventModal('Delete', item)}
                  variant="normal"
                  wrapText={false}
                  requiredPermission="ADMINISTER"
                  actionDescription="delete model version events"
                >
                  Delete
                </PermissionAwareButton>
              </SpaceBetween>
            ),
          },
        ]}
        loading={isLoading}
        data={data || []}
        title="Events"
        error={error}
        emptyText="No Model Version Events found."
        actions={
          <PermissionAwareButton
            onClick={() => {
              showModelEventModal('New', null);
            }}
            variant="primary"
            requiredPermission="ADMINISTER"
            actionDescription="create model version events"
          >
            Add Model Version Event{' '}
          </PermissionAwareButton>
        }
      />
      {modelVersionEventModalVisible && (
        <ModelVersionEventFormModal
          modalMode={modelVersionEventModalMode}
          values={modelEventModalValues}
          onClose={() => {
            setModelVersionEventModalVisible(false);
          }}
        />
      )}
    </>
  );
};
